<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="总表" lazy name="first">
      <zb :date="date" :dateType="dateType"></zb>
    </el-tab-pane>
    <el-tab-pane label="遥测越限统计（前十）" lazy name="second">
      <ycyx :date="date" :dateType="dateType"></ycyx>
    </el-tab-pane>
    <el-tab-pane label="遥信越位统计（前十）" lazy name="third">
      <yxyw :date="date" :dateType="dateType"></yxyw>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import zb from "./sjtj/zb";
  import ycyx from "./sjtj/ycyx";
  import yxyw from "./sjtj/yxyw";
  export default {
    name: "ztgy",
    data () {
      return {
        activeName: 'first'
      };
    },
    props: {
      date: {
        type: String
      },
      dateType: {
        type: String
      },
    },
    components: { zb, ycyx, yxyw },
    mounted () {

    },
    computed: {

    },
    watch: {

    },
    methods: {
      handleClick (tab, event) {
        console.log(tab, event);
      },
    },
  };
</script>

<style lang="less">
  .el-tabs {
    .el-tabs__header {
      margin: 0 0 1px;

      .el-tabs__nav-wrap {
        padding-left: 20px;
        background: #f8f8f9;
      }
    }
  }
</style>